module.exports = __webpack_public_path__ + "img/glossary icon.63fa5eac.svg";